const ChartCard = (props)=>{
    return(
        <div className="card-body text-center mx-auto pt-3 pb-3">
        <div className="d-flex ps-5 ">
        <h6 className="ps-5 text-light">
           {props.icon}  {props.icon1}  {props.icon2} 
        </h6>

        <h4 className="ps-2 text-light">
        {props.head1} {props.head2} {props.head3} 
        </h4>
       
        
        </div>
        <h5 className=" pb-2 text-light">
            {props.subhead} {props.subhead1} {props.subhead2} {props.subhead3} 
        </h5>
        
        
        
   
   </div> 
    );
}

export default ChartCard;